export enum AlertType {
  ERROR = 'error',
  SUCCESS = 'success',
}
